import { jsxs as h, jsx as r, Fragment as H } from "react/jsx-runtime";
import { WithBreakpoints as U } from "@instructure/platform-with-breakpoints";
import { Alert as y } from "@instructure/ui-alerts";
import { createContext as G, useState as x, useCallback as p, useRef as T, useEffect as q, useId as V, createElement as Y } from "react";
import { FocusRegionManager as J } from "@instructure/ui-a11y-utils";
import { ToggleDetails as K } from "@instructure/ui-toggle-details";
import { View as k } from "@instructure/ui-view";
import { PresentationContent as N, ScreenReaderContent as _ } from "@instructure/ui-a11y-content";
import { Link as Q } from "@instructure/ui-link";
import { Transition as X } from "@instructure/ui-motion";
import { Text as C } from "@instructure/ui-text";
import { createRoot as Z } from "react-dom/client";
const F = 5e3, L = {
  close: "Close",
  details: "Details",
  errorDetails: "Error details",
  defaultErrorMessage: "An error occurred making a network request"
};
function B() {
  const e = "flash_screenreader_holder";
  let n = document.getElementById(e);
  return n || (n = document.createElement("div"), n.id = e, n.setAttribute("role", "alert"), document.body.appendChild(n)), n;
}
let P = {
  timeout: F,
  liveRegion: B,
  strings: { ...L }
};
function ye(e) {
  P = {
    timeout: e.timeout ?? F,
    liveRegion: e.liveRegion ?? B,
    strings: { ...L, ...e.strings }
  };
}
function R() {
  return P;
}
const $ = G({
  setOnFailure: () => {
  },
  setOnSuccess: () => {
  }
});
function ee({ breakpoints: e = {}, children: n }) {
  const [t, o] = x({
    key: 0,
    screenReaderOnly: !0
  }), l = R(), c = p(() => {
    o((i) => ({
      ...i,
      message: void 0,
      status: void 0,
      screenReaderOnly: !0
    }));
  }, []), d = p((i, a = !1) => {
    o((s) => ({
      message: i,
      status: "error",
      key: s.key + 1,
      screenReaderOnly: a
    }));
  }, []), m = p((i, a = !0) => {
    o((s) => ({
      message: i,
      status: "success",
      key: s.key + 1,
      screenReaderOnly: a
    }));
  }, []), f = () => {
    const i = { position: "fixed", zIndex: 101 }, a = e.mobileOnly ? {
      left: "0",
      maxWidth: "100%",
      right: "0",
      top: "0",
      margin: "80px 20px"
    } : {
      left: "26%",
      maxWidth: "1125px",
      position: "fixed",
      right: "120px",
      top: "80px",
      zIndex: 101
    };
    return { ...i, ...a };
  }, g = () => t.status === "success" ? /* @__PURE__ */ r(
    y,
    {
      variant: "success",
      liveRegion: l.liveRegion,
      onDismiss: c,
      screenReaderOnly: t.screenReaderOnly,
      timeout: l.timeout,
      children: t.message
    }
  ) : t.status === "error" ? /* @__PURE__ */ r(
    y,
    {
      liveRegion: l.liveRegion,
      margin: "small",
      onDismiss: c,
      timeout: l.timeout,
      screenReaderOnly: t.screenReaderOnly,
      variant: "error",
      children: t.message
    }
  ) : null;
  return /* @__PURE__ */ h($.Provider, { value: { setOnFailure: d, setOnSuccess: m }, children: [
    t.status && /* @__PURE__ */ r("div", { style: f(), children: g() }, t.key),
    n
  ] });
}
const ve = U(
  ee
);
function Re({
  error: e,
  closeable: n,
  liveRegionText: t,
  transferFocus: o,
  focusRef: l,
  children: c,
  onDismiss: d,
  ...m
}) {
  const [f, g] = x(!0), i = T(null), a = R(), s = p(() => {
    g(!1), d && d();
  }, [d]);
  return q(() => {
    if (o) {
      const u = (l ?? i).current;
      if (u === null) throw new Error("childrenRef did not appear as expected");
      J.focusRegion(u, {
        onBlur: () => {
        },
        onDismiss: () => {
        }
      });
    }
  }, []), /* @__PURE__ */ h("div", { children: [
    t && /* @__PURE__ */ r(y, { liveRegion: a.liveRegion, open: f, screenReaderOnly: !0, children: t }),
    /* @__PURE__ */ h(
      y,
      {
        ...m,
        variant: "error",
        renderCloseButtonLabel: n ? a.strings.close : void 0,
        onDismiss: s,
        children: [
          /* @__PURE__ */ r("div", { ref: i, tabIndex: -1, children: c }),
          e && /* @__PURE__ */ r(k, { as: "div", margin: "x-small 0 0", children: /* @__PURE__ */ r(K, { summary: a.strings.errorDetails, size: "small", children: /* @__PURE__ */ r(k, { as: "div", maxHeight: "12rem", margin: "x-small 0 0", overflowY: "auto", children: /* @__PURE__ */ r("pre", { children: /* @__PURE__ */ r("code", { children: e }) }) }) }) })
        ]
      }
    )
  ] });
}
function te(e) {
  return typeof e == "object" && e !== null && "message" in e && typeof e.message == "string";
}
function ne(e) {
  var o;
  let n = e.message, t;
  if ((o = e.response) != null && o.data)
    try {
      Array.isArray(e.response.data.errors) ? (n = e.response.data.errors[0].message, t = e.message) : e.response.data.message && (n = e.response.data.message, t = e.message);
    } catch {
      n = e.message;
    }
  return { a: n, b: t };
}
function w(e) {
  return typeof e == "string" && e.toLowerCase().includes("loading chunk");
}
function M({ a: e, b: n }) {
  const t = e && !w(e), o = n && !w(n);
  return /* @__PURE__ */ h(C, { as: "p", fontStyle: "italic", children: [
    t && /* @__PURE__ */ r(C, { children: e }),
    o && /* @__PURE__ */ h(H, { children: [
      /* @__PURE__ */ r("br", {}),
      /* @__PURE__ */ r(C, { children: n })
    ] })
  ] });
}
function re({
  onClose: e,
  message: n,
  error: t,
  variant: o = "info",
  timeout: l = 5e3,
  screenReaderOnly: c = !1,
  liveRegionPoliteness: d,
  dismissible: m = !0
}) {
  const [f, g] = x(!1), [i, a] = x(!0), s = T(null), u = V(), b = R(), D = p(() => {
    a(!1), setTimeout(() => {
      s.current && clearTimeout(s.current), e();
    }, 500);
  }, [e]), W = p(() => {
    g(!0), s.current && clearTimeout(s.current), s.current = setTimeout(D, l);
  }, [D, l]);
  let O = null;
  if (t && te(t)) {
    const { a: E, b: A } = ne(t), z = E && !w(E), j = A && !w(A);
    (z || j) && (f ? O = /* @__PURE__ */ r(M, { a: E, b: A }) : O = /* @__PURE__ */ h("span", { children: [
      /* @__PURE__ */ r(N, { children: /* @__PURE__ */ r(
        Q,
        {
          isWithinText: !1,
          as: "button",
          onClick: W,
          "aria-describedby": u,
          children: b.strings.details
        }
      ) }),
      /* @__PURE__ */ r(_, { id: u, children: /* @__PURE__ */ r(M, { a: E, b: A }) })
    ] }));
  }
  return /* @__PURE__ */ r(X, { transitionOnMount: !0, in: i, type: "fade", children: /* @__PURE__ */ r(
    y,
    {
      variant: o,
      renderCloseButtonLabel: m ? b.strings.close : void 0,
      onDismiss: D,
      margin: "small auto",
      timeout: l,
      liveRegion: b.liveRegion,
      transition: "fade",
      screenReaderOnly: c,
      liveRegionPoliteness: d,
      children: /* @__PURE__ */ h("div", { children: [
        /* @__PURE__ */ r("p", { style: { margin: "0 -5px" }, children: n }),
        O
      ] })
    }
  ) });
}
function Ee({
  children: e,
  liveAlert: n,
  screenReaderOnly: t,
  politeness: o = "assertive",
  ...l
}) {
  let c = e;
  return (n || t) && (c = /* @__PURE__ */ r("span", { role: "alert", "aria-live": o, "aria-atomic": !0, children: c })), t ? /* @__PURE__ */ r(_, { children: c }) : /* @__PURE__ */ r(y, { ...l, children: c });
}
const S = "flashalert_message_holder", se = "flash_screenreader_holder", v = /* @__PURE__ */ new Map();
function I(e) {
  const {
    message: n,
    err: t,
    type: o = t ? "error" : "info",
    srOnly: l = !1,
    politeness: c,
    dismissible: d = !0
  } = e;
  if (typeof document > "u")
    return;
  const m = R();
  function f(s) {
    const u = v.get(s);
    if (u)
      try {
        u.unmount();
      } finally {
        v.delete(s);
      }
    s.remove();
  }
  function g() {
    let s = document.getElementById(S);
    return s || (s = document.createElement("div"), s.id = S, s.setAttribute(
      "style",
      "position: fixed; top: 0; left: 0; width: 100%; z-index: 100000; pointer-events: none;"
    ), document.body.appendChild(s)), s;
  }
  const i = document.createElement("div");
  i.setAttribute("style", "max-width:50em;margin:1rem auto;pointer-events:auto;"), i.setAttribute("class", "flashalert-message"), g().appendChild(i);
  const a = Z(i);
  v.set(i, a), a.render(
    Y(re, {
      message: n,
      timeout: m.timeout,
      error: t,
      variant: o,
      onClose: () => f(i),
      screenReaderOnly: l,
      liveRegionPoliteness: c,
      dismissible: d
    })
  );
}
function Ae() {
  const e = document.getElementById(S), n = document.getElementById(se);
  if (e) {
    for (const [t, o] of v)
      e.contains(t) && (o.unmount(), v.delete(t));
    e.remove();
  }
  n && n.remove();
}
function xe(e) {
  return (n) => {
    const t = R();
    I({
      message: e ?? t.strings.defaultErrorMessage,
      err: n,
      type: "error"
    });
  };
}
function we(e) {
  return () => I({ message: e, type: "success" });
}
function be(e) {
  return () => I({ message: e, type: "warning" });
}
export {
  ve as AlertManager,
  $ as AlertManagerContext,
  Re as ExpandableErrorAlert,
  re as FlashAlert,
  Ee as InlineAlert,
  ye as configureAlerts,
  Ae as destroyContainer,
  I as showFlashAlert,
  xe as showFlashError,
  we as showFlashSuccess,
  be as showFlashWarning
};
